import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { Folder } from "../server/folder-service";
import { SupabaseFolderService } from "../server/folder-service";

export const useFolders = (): ReturnType<typeof useSupabaseLoader<Folder[]>> => {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseFolderService(supabase).getAll(account_id, {
      order: [{ column: "created_at" }],
      filter: [{ key: "deleted_at", operator: "is", value: null }],
    });
    if (error) throw new Error(error.message);
    return data;
  }, []);
};
